// extracted by mini-css-extract-plugin
export default {"container":"landing_container__Rn3Hg","title":"landing_title__aHo+X","boton":"landing_boton__YXYjx","copyright":"landing_copyright__pYDL1"};